/* Jondal Cart-Popup: Rabattcode ueber /cart/update.js, Chips aus der Cart-JSON, Neurender ueber Dawn */
(function () {
  if (window.__gCart) return;
  window.__gCart = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function drawer() { return document.querySelector('cart-drawer'); }
  function codesEl() { return document.querySelector('[data-g-codes]'); }
  function errorEl() { return document.querySelector('[data-g-discount-error]'); }

  function showError(msg) {
    var el = errorEl();
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderChips(discountCodes) {
    var el = codesEl();
    if (!el || !Array.isArray(discountCodes)) return;
    var html = '';
    discountCodes.forEach(function (dc) {
      if (!dc || !dc.applicable) return;
      var code = escapeHtml(dc.code);
      html += '<span class="g-cart__code" data-g-code="' + code + '">' +
        '<span class="g-cart__code-check" aria-hidden="true"><svg viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.3 4.3 7.6 11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        code +
        '<button type="button" class="g-cart__code-remove" data-g-discount-remove="' + code + '" aria-label="Remove code ' + code + '"><svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l8 8M9 1 1 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
        '</span>';
    });
    el.innerHTML = html;
  }

  function currentCodes() {
    return Array.prototype.map.call(document.querySelectorAll('[data-g-code]'), function (n) { return n.getAttribute('data-g-code'); });
  }

  function refreshFromCart() {
    fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && Array.isArray(cart.discount_codes)) renderChips(cart.discount_codes); })
      .catch(function () {});
  }

  function applyCodes(codes, addedCode) {
    var form = document.querySelector('[data-g-discount-form]');
    var btn = form ? form.querySelector('.g-cart__apply') : null;
    if (btn) btn.disabled = true;
    showError('');
    var body = { discount: codes.join(','), sections: SECTIONS, sections_url: window.location.pathname };
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || state.status || state.errors) {
          showError((state && (state.description || state.message || state.errors)) || 'Something went wrong. Please try again.');
          return;
        }
        var d = drawer();
        if (d && state.sections) d.renderContents(state);
        var dcs = Array.isArray(state.discount_codes) ? state.discount_codes : null;
        if (dcs) {
          renderChips(dcs);
          if (addedCode) {
            var hit = dcs.filter(function (x) { return x && x.code && x.code.toUpperCase() === addedCode.toUpperCase(); })[0];
            if (!hit || !hit.applicable) showError('This code is not valid for your cart.');
          }
        } else if (addedCode) {
          /* Aeltere Cart-API ohne discount_codes: Code per Discount-Link fuer den Checkout merken */
          fetch('/discount/' + encodeURIComponent(addedCode), { redirect: 'manual', credentials: 'same-origin' }).catch(function () {});
          renderChips([{ code: addedCode, applicable: true }]);
        }
        var input = document.querySelector('[data-g-discount-input]');
        if (input) input.value = '';
      })
      .catch(function () { showError('Something went wrong. Please try again.'); })
      .finally(function () {
        var b = document.querySelector('[data-g-discount-form] .g-cart__apply');
        if (b) b.disabled = false;
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-g-discount-form]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('[data-g-discount-input]');
    var code = input ? input.value.trim().toUpperCase() : '';
    if (!code) { showError('Please enter a code.'); return; }
    var codes = currentCodes().filter(function (c) { return c.toUpperCase() !== code; });
    codes.push(code);
    applyCodes(codes, code);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-g-discount-remove]');
    if (!btn) return;
    event.preventDefault();
    var remove = btn.getAttribute('data-g-discount-remove');
    var codes = currentCodes().filter(function (c) { return c !== remove; });
    applyCodes(codes, null);
  });

  /* Chips nachziehen, wenn das Popup aufgeht oder Dawn den Warenkorb neu rendert */
  function watch() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(function () {
      if (d.classList.contains('active')) refreshFromCart();
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshFromCart, 50); });
  }
})();
